import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'

import Button from '@shared/ui/button'

import Item from './Item'

import styles from './styles.module.scss'

type PaymentModalProps = {
  onChoose: (id: string) => void;
  current: string | null;
};

export default function PaymentModal ({ onChoose, current }: PaymentModalProps) {
  const { paymentMethods, handleDefault, defaultCard } =
    useManagePaymentMethods()
  const { closeAllModals } = useModalStore()
  const { t: tc } = useTranslation('common')
  const [ selected, setSelected ] = useState<string | null>(
    current === 'new-card' ? current : null,
  )

  const onSelect = (id: string | null) => {
    setSelected(id)
  }

  const handleChoose = () => {
    if (selected) {
      onChoose(selected)
    }
    else {
      onChoose(defaultCard?.id as string)
    }
    closeAllModals()
  }

  const handleItemSelect = (id: string) => {
    setSelected(null)
    handleDefault(id)
  }

  return (
    <div className={styles.root}>
      <div className={styles.root__cards}>
        <Item
          key="new-card"
          data={null}
          isSelected={selected === 'new-card' || !paymentMethods.length}
          onSelect={() => onSelect('new-card')}
        />
        {paymentMethods.map((el) => (
          <Item
            key={el?.id}
            data={el}
            isSelected={defaultCard?.id === el?.id && selected !== 'new-card'}
            onSelect={() => handleItemSelect(el?.id as string)}
          />
        ))}
      </div>
      <Button
        onClick={handleChoose}
        className={styles.root__button}
        size="large"
      >
        {tc('choose')}
      </Button>
    </div>
  )
}
